import { render } from "./SurveyModal.vue?vue&type=template&id=0cbd0f16&scoped=true"
import script from "./SurveyModal.vue?vue&type=script&lang=js"
export * from "./SurveyModal.vue?vue&type=script&lang=js"

import "./SurveyModal.vue?vue&type=style&index=0&id=0cbd0f16&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbd0f16"]])

export default __exports__